import API from "shared/services/Api";
import { IFiles } from "shared/types/File";

export const getPdf = async (data: IFiles) => {
  const downloadUrl = data.file?.download_url;

  if (!downloadUrl) {
    throw new Error("URL de download não encontrada.");
  }

  const uriParts = downloadUrl.split("api/");

  if (uriParts.length < 2 || !uriParts[1]) {
    throw new Error("Formato de URL inválido. Esperado caminho com 'api/'.");
  }

  const endpoint = `${uriParts[1]}?id=${data.userId}&idPac=${data.idPac}`;

  return API.get(endpoint, {
    responseType: "blob",
  });
};
